import { render, staticRenderFns } from "./tiga-notice-detail.vue?vue&type=template&id=d5a80abe&scoped=true"
import script from "./tiga-notice-detail.vue?vue&type=script&lang=js"
export * from "./tiga-notice-detail.vue?vue&type=script&lang=js"
import style0 from "./tiga-notice-detail.vue?vue&type=style&index=0&id=d5a80abe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a80abe",
  null
  
)

export default component.exports